exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearfix[data-v-6c836ad2]:after,.clearfix[data-v-6c836ad2]:before{display:table;content:\"\"}.clearfix[data-v-6c836ad2]:after{clear:both}.box-card[data-v-6c836ad2]{width:100%;margin-top:20px}", ""]);

// exports
